import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { DataProvider } from './contexts/DataContext';
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import Documents from './pages/Documents';

// Pages Admin (à créer)
import AdminGateway from './pages/admin/AdminGateway';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';

const TOKEN_STORAGE_KEY = 'auth_token';

const RequireAuth: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const token = typeof window !== 'undefined' ? window.localStorage.getItem(TOKEN_STORAGE_KEY) : null;
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <DataProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/crac-console" element={<AdminGateway />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<RequireAuth><AdminDashboard /></RequireAuth>} />
          </Routes>
        </Layout>
      </Router>
    </DataProvider>
  );
}

export default App;